module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-165.18f0cff.woff2";